import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { AccounDataDTO, UserService } from 'synergy-core';

@Component({
  selector: 'app-password-forgotten',
  templateUrl: './password-forgotten.component.html',
  styleUrls: ['./password-forgotten.component.sass']
})
export  class PasswordForgottenComponent {


  emailForm!: FormGroup;
  submitted = false;
  returnUrl!: string;
  passwordIsValid = false;
  passwordSent = false;
  currentUser!: AccounDataDTO;

  constructor(
    private router: Router,
    private userAccountService: UserService
  ) {

  }

  ngOnInit() {

    
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');   
    

    this.emailForm = new FormGroup({
      mailAddress: new FormControl('', [Validators.required, Validators.email])
    });
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.emailForm.invalid) {
      return;
    }

    const httpParams = new HttpParams().set("emailAddress",this.emailForm.value.mailAddress);

    this.userAccountService.GetTemporaryPassword(0,this.currentUser.ClientId ,this.emailForm.value.mailAddress).pipe(
      catchError((error) => {
        throw error;
      })).subscribe((data) => {
        if (data) {
          this.passwordSent = true;
        }
      });

  }

  onCancel() {
    this.router.navigate(['/']);
  }

  get f() { return this.emailForm.controls; }

}
